import Navbar from '../Navbar'
import { useEffect, useState } from 'react'
import { Get_Subject_ID } from '../../api/api'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import Loading from '../Loading'
import ItemsTypeSingle from '../loops/itemsTypeSingle'
import SoldsDataTable from '../dashboard/ADMIN/components/SoldsDataTable'
import TrafficStatsTable from '../dashboard/TrafficStatsTable'

export default function TypeSingle() {
  const [loading, setLoading] = useState(true)
  const [response, setResponse] = useState({})
  const params = useParams()

  useEffect(() => {
    const getContent = async () => {
      try {
        const res = await axios.get(Get_Subject_ID + params.contentId)
        setResponse(res.data)
      } finally {
        setLoading(false)
      }
    }

    getContent()
  }, [params.contentId])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <Navbar search={false} nav={false} breadcrumb={false} />

          <div className="contentHolder">
            <ItemsTypeSingle data={response} notSingle={true} />
          </div>

          <div className="contentHolder" style={{ paddingTop: '0' }}>
            <SoldsDataTable
              title={response.title}
              SubjectId={params.contentId}
            />

            <div className="row">
              <div className="col-md-12">
                <TrafficStatsTable
                  title="آمار ترافیک"
                  titleExtra={<small> ({response.title}) </small>}
                  source="single"
                  subjectId={params.contentId}
                  priceField="publisherPrice"
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}
